export enum RequestsConditionsEnum {
    PROCESSES = 'processes',
    EXPIRED = 'expired',
    REQUEST = 'ongoing',
    CANCELED = 'canceled',
    CORRECTED = 'corrected',
    ALL = 'all'
}
